import React, { useState, useEffect } from 'react';
import { useParams, useHistory, Link } from 'react-router-dom';
import { EventEmitter } from 'events';
import { connect, isSupported } from 'twilio-video';
import { graphqlOperation, API} from "aws-amplify";
import { Connect } from "aws-amplify-react";
import Participant from './Participant';
import DeviceManager from './Devices';
import Token from './helpers/Token';
import * as queries from './graphql/queries';
import * as mutations from './graphql/mutations';
import * as subscriptions from './graphql/subscriptions';

const Room = () => {
  const { room_id } = useParams();
  const history = useHistory();

  const [room, setRoom] = useState(null);
  const [participants, setParticipants] = useState([]);
  const [bg, setBg] = useState(false);
  const [pvw, setPvw] = useState(true);
  const [hasAudio, setHasAudio] = useState(false);
  const [hasVideo, setHasVideo] = useState(false);
  const [isLive, setIsLive] = useState(false);
  const [recParticipants, setRecParticipants] = useState([]);
  const eventTrigger = new EventEmitter();



  var jwt = Token(room_id);
  let localDevices = new DeviceManager

  useEffect(() => {
    eventTrigger.on('notif_trigger', () => {
      guestNotification();
    });
  }, []);

  useEffect(() => {
    const participantConnected = participant => {
      console.log(participant)
      setParticipants(prevParticipants => [...prevParticipants, participant]);
      eventTrigger.emit('notif_trigger');
    };

    const participantDisconnected = participant => {
      setParticipants(prevParticipants =>
        prevParticipants.filter(p => p !== participant)
      );
    };

    localDevices.init().then(v => {
      let devices = {};
      v.forEach(device => {
        devices = Object.assign({}, devices, device);
      });
      setHasAudio(devices.audio);
      setHasVideo(devices.video);


      connect(jwt, {
        name: room_id,
        audio: devices.audio,
        video: (devices.video)?{ width: 1280, height:720, aspectRatio:1280/720 }:false
      }).then(room => {
        setRoom(room);
        room.on('participantConnected', participantConnected);
        room.on('participantDisconnected', participantDisconnected);
        room.participants.forEach(participantConnected);
      });

    });

    return () => {
      setRoom(currentRoom => {
        if (currentRoom && currentRoom.localParticipant.state === 'connected') {
          currentRoom.localParticipant.tracks.forEach(function(trackPublication) {
            trackPublication.track.stop();
          });
          currentRoom.disconnect();
          return null;
        } else {
          return currentRoom;
        }
      });
    };
  }, []);

  const completeRoom = async (sid, thisRoom) => {
    thisRoom.disconnect();
    const room = await API.graphql(graphqlOperation(mutations.completeRoom, {sid}));
    console.log(room);
    history.push('/myrooms')
  }

  const MuteButton = (props) => {
    if (props.device) {
      var trackTypes = props.device === "microphone" ? "audioTracks" : "videoTracks"
    }
    else throw Error("No device type specified for mute control.")

    const [muted, muteDevice] = useState(false)
    const muteHandler = () => {
      if (!muted) {
        room.localParticipant[trackTypes].forEach(publication => {
          console.log(`Muting ${props.device}`)
          publication.track.disable();
        });
      } else {
        room.localParticipant[trackTypes].forEach(publication => {
          console.log(`Unmuting ${props.device}`)
          publication.track.enable();
        });
      }
      muteDevice(muted ? false : true)
    }

    if (props.device === "microphone") {
      return (
        <i className={`fas ${muted ? "mute-button-enabled fa-microphone-slash" : "mute-button-disabled fa-microphone"}`} onClick={muteHandler}></i>)
    } else {
      return (
        <i className={`fas ${muted ? "mute-button-enabled fa-video-slash" : "mute-button-disabled fa-video"}`} onClick={muteHandler}></i>)
    }
  }

  console.log(participants)

  if (isSupported) {
    return (
        <div>
            <div className="roomhead">
              <Connect query={graphqlOperation(queries.getRoom, {id:room_id})}
              subscription={graphqlOperation(subscriptions.updatedSingleRoom, {id:room_id})}
              onSubscriptionMsg={(prev, { updatedSingleRoom }) => {
                  if (!isLive) {
                    console.log({updatedSingleRoom})
                    setRecParticipants([...new Set(updatedSingleRoom.rawRecordings.map(x => x.participant_sid))])
                    return {getRoom: updatedSingleRoom};
                  }
                  return prev;
              }}>
                {({loading, error, data}) => {
                  if (loading) return <>loading...</>
                  if (error) return <>error</>
                  if (data.getRoom.type === "live")
                    setIsLive(true);

                  console.log(data.getRoom)

                  return (
                    <>
                      <h1>{data.getRoom.title}</h1>

                      <button onClick={() => completeRoom(data.getRoom.sid, room)}>End Interview</button>
                      <h2>Link: <input type="text" value={`https://${process.env.REACT_APP_API_DOMAIN}/guest/${room_id}`} readOnly={true} /></h2>
                      {isLive && <div>
                        <input type="checkbox" checked={bg} onChange={ () => setBg(!bg)} />Background<br/>
                        {hasVideo && <><input type="checkbox" onChange={ () => setPvw(!pvw)} checked={pvw} />Show my preview</>}
                      </div>}
                    </>
                  )}}
              </Connect>
            </div>
            <div className={bg?"videos live":"videos"} id="videos">
              <div id="local-media" className="local">
                {room && pvw? (
                  <Participant
                    key={room.localParticipant.sid}
                    participant={room.localParticipant}
                  />
                ) : (
                  ''
                )}
              </div>
              <div className="remote-participants">
                {participants.map(participant => {
                  if (isLive) {
                    return <Link to={`/rooms/${room_id}/isos/${participant.sid} `} key={participant.sid} className={participants.length>1?'multiple':''}>
                      <Participant participant={participant} total={participants.length} recParticipants={recParticipants} />
                    </Link>
                  }
                  else return <Participant key={participant.sid} recParticipants={recParticipants} participant={participant} total={participants.length} />
                })}
                  <div id="mute-controls">
                    <div id="mute-microphone">
                      <MuteButton device={"microphone"} />
                    </div>
                    <div id="mute-camera">
                      <MuteButton device={"camera"} />
                    </div>
                  </div>
                </div>
            </div>
        </div>
      )
  } else {
    return (
      <div><h2>Browser not supported.</h2></div>
    )
  }
}

function guestNotification() {
  if("Notification" in window ) {
    new Notification('Guest Notification', {
      body: 'A guest has joined the room.',
    });
  } else {
    console.error('Error: ', 'Platform does not support "Desktop Notifications".')
  };
};

export default Room;